//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  faLayerGroup,
  faCopy,
  faCoins,
  faArrowDown,
} from '@fortawesome/pro-solid-svg-icons';

export default {
  name: 'ReferralSteps',
  components: {
    HomeBenefits: () => import('@/components/home-page/HomeBenefits.vue'),
    StepItem: () => import('@/components/core/elements/StepItem.vue'),
  },
  data() {
    return {
      faArrowDown,
      steps: [
        {
          icon: faLayerGroup,
          color: 'primary',
          heading: this.$t(this.$wbr('affiliate_program.step_1_heading')),
          text: this.$t(this.$wbr('affiliate_program.step_1_text')),
        },
        {
          icon: faCopy,
          color: 'warning',
          heading: this.$t(this.$wbr('affiliate_program.step_2_heading')),
          text: this.$t(this.$wbr('affiliate_program.step_2_text')),
        },
        {
          icon: faCoins,
          color: 'aqua',
          heading: this.$t(this.$wbr('affiliate_program.step_3_heading')),
          text: this.$t(this.$wbr('affiliate_program.step_3_text')),
        },
      ],
    };
  },
};
